import { Icon } from '@/components/atoms';
import type { IconProps } from '@/components/atoms';

interface SummaryCard {
  label: string;
  value: string | number;
  icon: IconProps['name'];
  color: 'primary' | 'success' | 'warning' | 'info' | 'error';
  format?: 'number' | 'currency' | 'percentage';
}

interface ReportSummaryCardsProps {
  cards: SummaryCard[];
}

const colorClasses = {
  primary: { bg: 'bg-primary-50', icon: 'text-primary-600' },
  success: { bg: 'bg-success-50', icon: 'text-success-600' },
  warning: { bg: 'bg-warning-50', icon: 'text-warning-600' },
  info: { bg: 'bg-info-50', icon: 'text-info-600' },
  error: { bg: 'bg-error-50', icon: 'text-error-600' },
};

function formatValue(value: string | number, format?: string): string {
  if (typeof value === 'string') return value;

  switch (format) {
    case 'currency':
      return `₹${value.toLocaleString('en-IN')}`;
    case 'percentage':
      return `${value.toFixed(1)}%`;
    case 'number':
    default:
      return value.toLocaleString('en-IN');
  }
}

export function ReportSummaryCards({ cards }: ReportSummaryCardsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {cards.map((card, index) => {
        const colors = colorClasses[card.color];
        return (
          <div key={index} className="bg-white rounded-lg shadow-sm border border-neutral-200 p-6">
            <div className="flex items-center justify-between mb-2">
              <p className="text-sm font-medium text-neutral-600">{card.label}</p>
              <div className={`${colors.bg} p-2 rounded-lg`}>
                <Icon name={card.icon} size={20} className={colors.icon} />
              </div>
            </div>
            <p className="text-2xl font-bold text-neutral-900">
              {formatValue(card.value, card.format)}
            </p>
          </div>
        );
      })}
    </div>
  );
}
